import React from "react";
import PropTypes from "prop-types";
import "../styles/Legend.css";

const Legend = ({ colors, labels, description, type = "gradient", shape = "circle" }) => {
  const leftLabel = labels[0] || "";
  const rightLabel = labels[1] || "";

  const renderLegend = () => {
    // 1) DOT LEGEND
    if (type === "dot") {
      return (
        <div className="legend-content">
          {colors.map((color, index) => (
            <div key={index} className="legend-item">
              <div className="legend-dot" style={{ backgroundColor: color }} />
              <span className="legend-label">{labels[index]}</span>
            </div>
          ))}
        </div>
      );
    }

    // 2) CLASSED-COLOR LEGEND
    if (type === "classed-color") {
      // If shape is "square", use .legend-square; else fallback to .legend-dot
      const shapeClass = shape === "square" ? "legend-square" : "legend-dot";

      return (
        <div className="legend-content classed-legend">
          {colors.map((color, index) => (
            <div key={index} className="legend-item">
              <div className={shapeClass} style={{ backgroundColor: color }} />
              <span className="legend-label">{labels[index]}</span>
            </div>
          ))}
        </div>
      );
    }

    // 3) GRADIENT LEGEND (default if type === "gradient")
    return (
      <div className="legend-content">
        <span className="legend-label left-label">{leftLabel}</span>
        <div
          className="legend-gradient-bar"
          style={{
            background: `linear-gradient(to right, ${colors.join(", ")})`,
          }}
        />
        <span className="legend-label right-label">{rightLabel}</span>
      </div>
    );
  };

  return (
    <div className="legend-container">
      {description && <p className="legend-description">{description}</p>}
      {renderLegend()}
    </div>
  );
};

Legend.propTypes = {
  colors: PropTypes.arrayOf(PropTypes.string).isRequired,
  labels: PropTypes.arrayOf(PropTypes.string).isRequired,
  title: PropTypes.string,
  description: PropTypes.string, // New prop for description
  type: PropTypes.oneOf(["gradient", "dot", "classed-color"]),
  shape: PropTypes.oneOf(["circle", "square"]),
};

export default Legend;
